"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const recoil_1 = require("recoil");
const styles_1 = require("@material-ui/core/styles");
const components_1 = require("@alcumus/components");
const ReportViewToggle_1 = require("../shared/ReportViewToggle");
const SubFolderTableView_1 = __importDefault(require("./SubFolderTableView"));
const FoldersRoute_1 = __importDefault(require("../../../routes/FoldersRoute"));
const withLoading_1 = require("../../hocs/withLoading");
const reportElementTypes_1 = require("../../../domain/reportElementTypes");
const ReportsTileView_1 = __importDefault(require("../ReportTiles/ReportsTileView"));
const EmptyFolderState_1 = __importDefault(require("../EmptyState/EmptyFolderState"));
const useStyles = (0, styles_1.makeStyles)((theme) => (0, styles_1.createStyles)({
    container: {
        paddingTop: 0,
    },
    title: {
        lineHeight: `${theme.spacing(3)}px`,
        fontWeight: components_1.StyleVariables.fonts.weight.medium,
        paddingBottom: theme.spacing(3),
    },
}));
const HomePageFolderList = ({ folders, showTitle = true, }) => {
    const classes = useStyles();
    const [toggleView] = (0, recoil_1.useRecoilState)(ReportViewToggle_1.tableTileViewSwitcherState);
    if (!folders.length)
        return react_1.default.createElement(react_1.default.Fragment, null);
    const headers = [
        { id: 'elementType', displayName: 'Type' },
        { id: 'name', displayName: 'Name' },
    ];
    const finalFolders = folders.map((folder) => {
        return {
            id: folder.id,
            name: folder.name,
            basePath: `${FoldersRoute_1.default.path}/${folder.id}` || '',
            folder: folder.name,
            folderId: folder.id,
            contentFavoriteId: 0,
            contentMetadataId: 0,
            userId: folder.creatorId,
            createdAt: 0,
            createdBy: `${folder.creatorId}`,
            dashboards: folder.dashboards?.length || 0,
            looks: folder.looks?.length || 0,
            creatorId: folder.creatorId,
            elementType: reportElementTypes_1.ReportElementTypes.Folder,
        };
    });
    return (react_1.default.createElement("div", null,
        !!showTitle && (react_1.default.createElement(components_1.Text, { as: "h3", className: classes.title },
            "Folders (",
            finalFolders.length,
            ")")),
        toggleView === 'table' && (react_1.default.createElement(SubFolderTableView_1.default, { data: finalFolders ?? [], headers: headers, showCreateButton: false })),
        toggleView === 'tile' && (react_1.default.createElement(ReportsTileView_1.default, { isLoading: false, data: finalFolders, title: "Folders", id: "folderTiles", headers: headers.map((header) => header.displayName), emptyState: react_1.default.createElement(EmptyFolderState_1.default, { showCreateButton: false }) }))));
};
exports.default = (0, withLoading_1.withSkeletonLoading)(HomePageFolderList);
